var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3 mb-2 med--text d-flex align-center"},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"mr-2 body-2"},[_vm._t("default")],2),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }